import type { ActionAppFacilities } from "@glide/common-core/dist/js/components/types";
import { type ClassScreenDescription, type MutatingScreenKind, ScreenDescriptionKind } from "@glide/app-description";
import type { InteractiveComponentConfiguratorContext } from "@glide/function-utils";
import { mapFilterUndefinedAsync } from "@glide/support";
import { inputOutputTablesForClassOrArrayScreen } from "./description-utils";
import { duplicateComponent } from "./handlers";

export async function copyClassScreen<T extends ClassScreenDescription>(
    screenDesc: T,
    iccc: InteractiveComponentConfiguratorContext,
    mutatingScreenKind: MutatingScreenKind | undefined,
    screensCreated: Set<string>,
    appFacilities: ActionAppFacilities
): Promise<T | undefined> {
    const tables = inputOutputTablesForClassOrArrayScreen(screenDesc, iccc.schema);
    if (tables === undefined) return undefined;

    return {
        ...screenDesc,
        components: await mapFilterUndefinedAsync(screenDesc.components, c =>
            duplicateComponent(c, tables, iccc, mutatingScreenKind, screensCreated, appFacilities)
        ),
    };
}

export async function copyClassOrArrayScreen(
    screenDesc: ClassScreenDescription,
    iccc: InteractiveComponentConfiguratorContext,
    mutatingScreenKind: MutatingScreenKind | undefined,
    screensCreated: Set<string>,
    appFacilities: ActionAppFacilities
): Promise<ClassScreenDescription | undefined> {
    const tables = inputOutputTablesForClassOrArrayScreen(screenDesc, iccc.schema);
    if (tables === undefined) return undefined;

    if (screenDesc.kind !== ScreenDescriptionKind.Class) return undefined;

    return {
        ...screenDesc,
        components: await mapFilterUndefinedAsync(screenDesc.components, c =>
            duplicateComponent(c, tables, iccc, mutatingScreenKind, screensCreated, appFacilities)
        ),
    };
}
